export function formatProgress(percent: number): string {
  return `${Math.floor(percent)}%`;
}
